module.exports = __webpack_public_path__ + "static/media/welcomeImage.4183434c.png";